module.exports = __webpack_public_path__ + "img/gongwu.9e347c3b.png";